export enum TenureTypes {
  // hometrackV2: Delete when beta gone
  ANY = "Any",
  FREEHOLD = "F",
  LEASEHOLD = "L",
  SHARED = "S",
}

export enum TenureLabels {
  // hometrackV2: Delete when beta gone
  ANY = "comparables.property.tenure.any",
  L = "comparables.property.tenure.leasehold",
  F = "comparables.property.tenure.freehold",
  S = "comparables.property.tenure.shared",
}
